import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Reward from '@/components/Reward'
import Promotion from '@/components/Promotion'
import Blog from '@/components/Blog'
import Point from '@/components/Point'
import Card from '@/components/Card'
import Account from '@/components/Account'
import Activity from '@/components/Activity'
import Page404 from '@/components/Page404'
import Register from '@/components/Register'
import QrcodeScan from '@/components/QrcodeScan'
import Package from '@/components/Package'
import Example from '@/components/Example'
import HowToGetCoin from '@/components/HowToGetCoin'
import CUSTOM from '@/components/HomeCUSTOM'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '*',
    name: '404',
    component: Page404
  },
  {
    path: '/',
    name: 'root',
    component: Home.Home,
    meta: { title: 'Home Page' }
  },
  {
    path: '/LinCheckContract',
    name: 'LinCheckContract',
    component: Home.LinCheckContract
  },
  {
    path: '/liff-login',
    name: 'LiffLogin',
    component: Home.LiffLogin,
    meta: { title: 'Login' }
  },
  {
    path: '/CredisHistory',
    name: 'CredisHistory',
    component: Home.CredisHistory
  },
  {
    path: '/test',
    name: 'test',
    component: Home.Test
  },
  {
    path: '/packageQRcode',
    name: 'packageQRcode',
    component: Package.CollecPackage
  },
  {
    path: '/HowToGetCoin',
    name: 'HowToGetCoin',
    component: HowToGetCoin
  },
  {
    path: '/MyPackage',
    name: 'MyPackage',
    component: Package.MyPackage
  },
  {
    path: '/home',
    name: 'home',
    component: Home.Home
  },
  {
    path: '/CLYN',
    name: 'CLYN',
    component: CUSTOM.HomeCLYN
  },
  {
    path: '/C',
    name: 'CUSTOM',
    component: CUSTOM.Home
  },
  {
    path: '/C/activity',
    name: 'CUSTOMActivity',
    component: CUSTOM.CUSTOMMain
  },
  {
    path: '/DemoUI2',
    name: 'CUSTOMDemoUI2',
    component: CUSTOM.Home
  },
  {
    path: '/reward',
    name: 'reward',
    component: Reward.Reward
  },
  {
    path: '/reward/detail/:id',
    name: 'rewarddetail',
    component: Reward.Detail
  },
  {
    path: '/reward/addAddress/:id',
    name: 'addAddress',
    component: Reward.UserAddress
  },
  {
    path: '/collect',
    name: 'collect',
    component: Point.Collect
  },
  {
    path: '/card',
    name: 'card',
    component: Card.Main
  },
  {
    path: '/StampCard',
    name: 'StampCard',
    component: Card.StampCard
  },
  {
    path: '/StampRXTradex',
    name: 'StampRXTradex',
    component: Card.StampRXTradex
  },
  {
    path: '/privilege',
    name: 'privilege',
    component: Card.Privilege
  },
  {
    path: '/level',
    name: 'level',
    component: Card.Level
  },
  {
    path: '/C/level',
    name: 'Clevel',
    component: Card.LMGLevel
  },
  {
    path: '/transaction',
    name: 'transaction',
    component: Card.Transaction
  },
  {
    path: '/account',
    name: 'account',
    component: Account.Main
  },
  {
    path: '/activity',
    name: 'activity',
    component: Activity.Main
  },
  {
    path: '/RegisterMember',
    name: 'RegisterMember',
    component: Register.RegisterMember
  },
  {
    path: '/bankPage',
    name: 'bankPage',
    component: Register.bankPage
  },
  {
    path: '/MemberShop',
    name: 'MemberShop',
    component: Register.MemberShop
  },
  {
    path: '/tierBenefit',
    name: 'TierBenefit',
    component: Card.TierBenefit
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: Promotion.Promotion
  },
  {
    path: '/promotion/detail/:id',
    name: 'promotiondetail',
    component: Promotion.Detail
  },
  {
    path: '/blog',
    name: 'blog',
    component: Blog.Blog
  },
  {
    path: '/blog/detail/:id',
    name: 'blogdetail',
    component: Blog.Detail
  },
  {
    path: '/qrcodescan',
    name: 'qrcodescan',
    component: QrcodeScan.qrcodescan
  },
  {
    path: '/Mybranch',
    name: 'Mybranch',
    component: Account.Mybranch
  },
  {
    path: '/example',
    name: 'Example',
    component: Example
  },
  {
    path: '/PrivacyNotice',
    name: 'PrivacyNotice',
    component: Register.PrivacyNotice
  },
  {
    path: '/FriendGetFriend',
    name: 'FriendGetFriend',
    component: Activity.FriendGetFriend
  },
  {
    path: '/NewMyReward',
    name: 'NewMyReward',
    component: Card.NewMyReward
  },
  {
    path: '/BuyPackage/:id',
    name: 'BuyPackage',
    component: Package.BuyPackage
  },
  {
    path: '/UploadPaymentForPoint',
    name: 'UploadPaymentForPoint',
    component: Point.UploadPaymentForPoint
  },
  {
    path: '/selectPayment',
    name: 'selectPayment',
    component: Point.selectPayment
  },
  {
    path: '/Login',
    name: 'Login',
    component: Home.Login
  },
  {
    path: '/ExchangeToDiscount',
    name: 'ExchangeToDiscount',
    component: Home.ExchangeToDiscount
  },
  {
    path: '/MyPoints',
    name: 'MyPoints',
    component: Home.MyPoints
  },
  {
    path: '/BvpQuestion',
    name: 'BvpQuestion',
    component: Activity.BvpQuestions
  },
  {
    path: '/C/card',
    name: 'CUSTOMCard',
    component: Card.CUSTOMMain
  },
  {
    path: '/C/NewMyReward',
    name: '/CNewMyReward',
    component: Card.CUSTOMNewMyReward
  },
  {
    path: '/C/MyPackage',
    name: '/CMyPackage',
    component: CUSTOM.CUSTOMMyPackage
  },
  {
    path: '/C/tierBenefit',
    name: 'CUSTOMTierBenefit',
    component: Card.CUSTOMTierBenefit
  },
  {
    path: '/C/transaction',
    name: 'CUSTOMTransaction',
    component: Card.CUSTOMTransaction
  },
  {
    path: '/C/account',
    name: 'CUSTOMAccount',
    component: CUSTOM.CUSTOMMainAccount
  },
  {
    path: '/C/reward',
    name: 'customreward',
    component: CUSTOM.Reward
  },
  {
    path: '/C/reward/detail/:id',
    name: 'CUSTOMrewarddetail',
    component: CUSTOM.Detail
  },
  {
    path: '/C/reward/addAddress/:id',
    name: 'CUSTOMaddAddress',
    component: CUSTOM.UserAddress
  },
  {
    path: '/C/MyPoints',
    name: 'CUSTOMMyPoints',
    component: CUSTOM.MyPoints
  },
  {
    path: '/C/ExchangeToDiscount',
    name: 'CUSTOMExchangeToDiscount',
    component: CUSTOM.ExchangeToDiscount
  },
  {
    path: '/C/promotion',
    name: 'CUSTOMEpromotion',
    component: CUSTOM.CUSTOMPromotion
  },
  {
    path: '/C/promotion/detail/:id',
    name: 'CUSTOMEpromotiondetail',
    component: CUSTOM.CUSTOMDetail
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js